import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { lastValueFrom } from 'rxjs';
import { AppService } from 'src/app/services/app-service.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss']
})
export class ForgotPasswordComponent {
  constructor(private router: Router, private toastrService: ToastrService,
    private appService: AppService, private route: ActivatedRoute
  ) {

  }

  public otp: any = false;
  policy_number: string = '';
  email_Id: string = '';
  hasError: boolean = false;
  hasSError: boolean = false;
  ErrorMessage: string = '';
  resendLinkEmailID: string = '';
  loginForm: any;
  otpForm: any;

  isShowOtpPage: any;
  isShowSignup: any;
  hidePassword = true;
  ngOnInit() {
    this.loginForm = new FormGroup({
      username: new FormControl(null, [Validators.required])
    });
  }
  ngAfterViewInit() { }

  SFLogin() {
    if (this.loginForm.valid) {
      lastValueFrom(this.appService.getUserById(this.loginForm.value.username)).then((res: any) => {
        console.log("res", res);
        if (res) {
          this.toastrService.success('Please check your email for the reset password link', 'Success');
          this.router.navigate(['login']);
          let data = this.appService.encrypt(this.loginForm.value.username + '**' + new Date().getTime(), "Forgot Password Salt");
          this.appService.sendEmail({
            recipient_email: this.loginForm.value.username,
            subject: 'Forgot Password',
            message: `Please click on the link to reset your password: <a href="${environment.siteUrl}reset-password/${data}">Reset Password</a>
              <br> <br> <b>Note:</b> This link is valid for 24 hours.
              <br> <br> <b>Note:</b> If you did not request this email, please ignore it.
              <br> <br>Thank you for using our service!`
          }).subscribe((res: any) => {
            this.toastrService.success("Please check your email for the reset password link", 'Success');
            this.router.navigate(['login']);
          });
        }
        else {
          this.toastrService.error('Invalid Email Id', 'Error');
          this.router.navigate(['login']);
        }
      }).catch((err: any) => {
        this.toastrService.error('Some error occured.', 'Error');
        throw Error("Some error occured.");
      });
      // .subscribe(
      //   (res: any) => {
      //     if (res['status'] == 'success') {
      //       this.toastrService.success('Please check your email for the reset password link', 'Success');
      //       this.router.navigate(['login']);
      //     } else {
      //       this.toastrService.error('Invalid User', 'Error');
      //     }
      //   },
      //   (err: any) => {
      //     this.toastrService.error('Invalid Email Id', 'Error');
      //   }
      // )

    } else {
      this.toastrService.warning('Invalid Details', 'Please Provide User Details');
    }
  }
}
